<div *ngIf="show" class="payment-backdrop fixed inset-0 z-[200]" (click)="onClose()">
    <div class="checkout-card" (click)="$event.stopPropagation()">
      <!-- Brand Banner -->
      <div class="brand-banner">
        <div class="flex flex-col">
          <span class="text-[10px] uppercase font-black tracking-widest text-white/60">Secure Checkout</span>
          <span class="text-xl font-black italic tracking-tighter">Razorpay</span>
        </div>
        <div class="px-3 py-1 bg-white/10 backdrop-blur-md rounded-lg border border-white/10">
          <span class="text-[10px] font-black uppercase tracking-widest">Test Mode</span>
        </div>
      </div>
  
      <!-- Checkout Body -->
      <div class="checkout-body">
        <!-- Summary Box -->
        <div class="summary-card">
          <h2 class="text-[10px] font-black uppercase tracking-widest text-slate-400 mb-4">Investment Summary</h2>
          
          <div class="flex items-start justify-between gap-6">
            <div class="flex-1">
              <p class="text-lg font-black text-slate-900 leading-tight mb-2">{{ getPaymentTitle() }}</p>
              <div class="flex flex-wrap gap-2">
                <span class="px-2 py-0.5 bg-white border border-slate-100 rounded-lg text-[9px] font-black uppercase text-slate-500">{{ getPaymentSubtitle() }}</span>
                <span *ngIf="paymentType === 'EVENT' && quantity > 1" class="px-2 py-0.5 bg-white border border-slate-100 rounded-lg text-[9px] font-black uppercase text-slate-500">{{ quantity }} UNITS</span>
              </div>
              <div *ngIf="paymentType === 'EVENT' && event" class="mt-4 flex items-center gap-3 text-slate-400">
                <span *ngIf="event.startDate" class="text-xs font-bold">{{ event.startDate | date:'MMM d, y' }}</span>
                <span class="text-xs opacity-30">|</span>
                <span *ngIf="event.location" class="text-xs font-bold">{{ event.location }}</span>
              </div>
            </div>
            
            <div class="text-right">
              <p class="text-2xl font-black text-slate-900 tracking-tighter">₹ {{ getPaymentAmount().toLocaleString('en-IN') }}</p>
              <p *ngIf="paymentType === 'EVENT' && quantity > 1" class="text-[10px] font-black uppercase text-slate-400 mt-2">
                ₹ {{ getEventPrice().toLocaleString('en-IN') }} / UNIT
              </p>
            </div>
          </div>
  
          <div class="total-row">
            <span class="text-xs font-black uppercase tracking-tighter text-slate-500">Total Amount</span>
            <span class="text-2xl font-black text-[#2b84ea] tracking-tighter">₹ {{ getPaymentAmount().toLocaleString('en-IN') }}</span>
          </div>
        </div>
  
        <!-- Payment Methods -->
        <div class="mb-6">
          <h3 class="text-[10px] font-black uppercase tracking-widest text-slate-400 mb-4">Payment Method</h3>
          <div class="grid grid-cols-1 md:grid-cols-2 gap-3">
            <label class="method-option" [class.selected]="selectedPaymentMethod === 'CREDIT_CARD'" (click)="setPaymentMethod('CREDIT_CARD')">
              <input type="radio" class="sr-only">
              <div class="w-10 h-10 bg-white rounded-xl flex items-center justify-center shadow-sm border border-slate-100 mr-3">
                <svg class="w-5 h-5 text-slate-700" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z"></path></svg>
              </div>
              <span class="text-xs font-black text-slate-900">Card</span>
            </label>
  
            <label class="method-option" [class.selected]="selectedPaymentMethod === 'UPI'" (click)="setPaymentMethod('UPI')">
              <input type="radio" class="sr-only">
              <div class="w-10 h-10 bg-white rounded-xl flex items-center justify-center shadow-sm border border-slate-100 mr-3">
                <svg class="w-5 h-5 text-slate-700" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 18h.01M8 21h8a2 2 0 002-2V5a2 2 0 00-2-2H8a2 2 0 00-2 2v14a2 2 0 002 2z"></path></svg>
              </div>
              <span class="text-xs font-black text-slate-900">UPI</span>
            </label>
          </div>
        </div>
  
        <!-- Dynamic Forms -->
        <div class="payment-form-area mb-6">
          <!-- Card Form -->
          <div *ngIf="selectedPaymentMethod === 'CREDIT_CARD'" class="space-y-3 animate-form">
            <div class="form-group">
              <label class="text-[9px] font-black uppercase text-slate-400 mb-1 block">Card Number</label>
              <input type="text" [(ngModel)]="cardDetails.number" placeholder="4242 4242 4242 4242" 
                class="w-full bg-slate-50 border border-slate-100 rounded-xl px-4 py-3 text-sm font-mono focus:ring-2 focus:ring-indigo-500 outline-none transition-all">
            </div>
            <div class="grid grid-cols-2 gap-3">
              <div class="form-group">
                <label class="text-[9px] font-black uppercase text-slate-400 mb-1 block">Expiry</label>
                <input type="text" [(ngModel)]="cardDetails.expiry" placeholder="MM / YY" 
                  class="w-full bg-slate-50 border border-slate-100 rounded-xl px-4 py-3 text-sm font-mono focus:ring-2 focus:ring-indigo-500 outline-none transition-all">
              </div>
              <div class="form-group">
                <label class="text-[9px] font-black uppercase text-slate-400 mb-1 block">CVV</label>
                <input type="password" [(ngModel)]="cardDetails.cvv" placeholder="•••" 
                  class="w-full bg-slate-50 border border-slate-100 rounded-xl px-4 py-3 text-sm font-mono focus:ring-2 focus:ring-indigo-500 outline-none transition-all">
              </div>
            </div>
            <div class="form-group">
              <label class="text-[9px] font-black uppercase text-slate-400 mb-1 block">Card Holder Name</label>
              <input type="text" [(ngModel)]="cardDetails.name" placeholder="FULL NAME" 
                class="w-full bg-slate-50 border border-slate-100 rounded-xl px-4 py-3 text-sm font-bold focus:ring-2 focus:ring-indigo-500 outline-none transition-all">
            </div>
          </div>

          <!-- UPI Form -->
          <div *ngIf="selectedPaymentMethod === 'UPI'" class="space-y-4 animate-form">
            <div class="grid grid-cols-3 gap-2">
              <button (click)="setUpiOption('GPAY')" [class.selected]="selectedUpiOption === 'GPAY'" class="upi-option">
                <div class="upi-logo-box">GPay</div>
              </button>
              <button (click)="setUpiOption('PHONEPE')" [class.selected]="selectedUpiOption === 'PHONEPE'" class="upi-option">
                <div class="upi-logo-box">PhonePe</div>
              </button>
              <button (click)="setUpiOption('PAYTM')" [class.selected]="selectedUpiOption === 'PAYTM'" class="upi-option">
                <div class="upi-logo-box">Paytm</div>
              </button>
            </div>
            
            <div class="pt-2">
              <button (click)="setUpiOption('OTHER')" [class.selected]="selectedUpiOption === 'OTHER'" 
                class="w-full text-left px-4 py-3 border border-slate-100 rounded-xl text-xs font-bold text-slate-600 hover:bg-slate-50 transition-all flex justify-between items-center">
                <span>Enter UPI ID</span>
                <span class="text-indigo-600">→</span>
              </button>
            <div *ngIf="selectedUpiOption === 'OTHER'" class="mt-2 animate-form">
              <input type="text" [(ngModel)]="upiId" placeholder="example@bank" (input)="errorMessage = ''"
                class="w-full bg-slate-50 border border-slate-100 rounded-xl px-4 py-3 text-sm font-medium focus:ring-2 focus:ring-indigo-500 outline-none transition-all">
            </div>
            </div>
          </div>
        </div>
  
        <!-- Status Messages -->
        <div *ngIf="errorMessage" class="mb-8 p-6 bg-rose-50 border border-rose-100 rounded-3xl text-rose-500 font-bold uppercase tracking-widest text-[10px] animate-bounce">
          ⚠️ {{ errorMessage }}
        </div>
  
        <!-- Primary Action -->
        <button (click)="processPayment()" [disabled]="processingPayment || !isFormValid()" class="pay-button">
          <span *ngIf="processingPayment" class="animate-spin h-5 w-5 border-3 border-white/20 border-t-white rounded-full"></span>
          <span *ngIf="!processingPayment" class="flex items-center gap-2">
             {{ getPaymentAmount() === 0 ? 'Confirm Selection' : 'Pay Now' }}
             <span *ngIf="getPaymentAmount() > 0" class="opacity-50">₹{{ getPaymentAmount().toLocaleString('en-IN') }}</span>
          </span>
        </button>
  
        <div class="flex items-center justify-center gap-6 mt-8">
            <div class="flex items-center gap-2 grayscale border border-slate-100 px-3 py-1.5 rounded-xl">
               <span class="text-[8px] font-black uppercase text-slate-400">Powered by</span>
               <span class="text-[10px] font-black italic text-slate-600">Razorpay</span>
            </div>
            <div class="flex items-center gap-2 grayscale border border-slate-100 px-3 py-1.5 rounded-xl">
                <span class="text-[8px] font-black uppercase text-slate-400">Encryption</span>
                <span class="text-[10px] font-black uppercase text-slate-600 tracking-widest">SSL 256</span>
             </div>
        </div>
  
        <button (click)="onClose()" [disabled]="processingPayment" class="cancel-link">
          Discard Checkout Session
        </button>
      </div>
    </div>
  </div>
